import { DataContract } from "./DataContract.js";

export class EntityContract extends DataContract {

    async queryCodelistData(query = null) {
        throw new Error(`${this.constructor.name}: queryCodelistData(query) is not implemented.`);
    }

}
